import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { getTranslation } from '../../../../../../common/react/utils/translations';

export const FixtureLiveTime = ({ match, liveMatch }) => {
    const matchClock = useRef();
    const timeRef = useRef();
    const matchId = liveMatch?.match.matchId
        ? liveMatch.match.matchId
        : match.providerId;
    const matchTime = useSelector((state) =>
        window.PULSE.app.redux.selectors.match.timeString(state, matchId)
    );

    useEffect(() => {
        if (matchTime?.string) {
            if (matchClock.current) {
                matchClock.current.updateTime();
            } else {
                matchClock.current = new PULSE.app.MatchClock(timeRef.current, {
                    countdownSuffix: getTranslation(
                        'label.fixtures.countdown-text'
                    )
                });
            }
        }
    }, [matchTime?.string]);

    return (
        <div
            className={`${matchTime.countdown ? 'is-countdown' : ''}`}
            data-provider-id={matchId}
            ref={timeRef}
            dangerouslySetInnerHTML={{ __html: matchTime.string }}
        />
    );
};

FixtureLiveTime.propTypes = {
    match: PropTypes.object,
    liveMatch: PropTypes.object
};
